import moment from 'moment';

class UserSubscriptions {
  constructor(data) {
    this.items = data;
  }

  get primary() {
    let primary = null;
    let expiryDate = null;

    this.items.forEach((item) => {
      const dateObject = item.expires_at;
      if (!item.has_expired && dateObject) {
        const currentDate = new Date(dateObject.value);
        if (!expiryDate || currentDate > expiryDate) {
          expiryDate = currentDate;
          primary = item;
        }
      }
    });

    return primary;
  }

  get stripe() {
    const stripe = this.items.find((item) => item.payment_provider === 'stripe' && !item.has_expired);
    return stripe || null;
  }

  get nextPaymentDate() {
    const { stripe } = this;
    if (stripe && stripe.upcoming_invoice) {
      if (stripe.upcoming_invoice) {
        return moment.unix(stripe.upcoming_invoice.next_payment_attempt).format('Do MMMM YYYY');
      }

      return moment(stripe.expires_at).format('Do MMMM YYYY');
    }

    return null;
  }

  get nextPaymentAmount() {
    const { stripe } = this;
    if (stripe && stripe.upcoming_invoice) {
      return stripe.upcoming_invoice.amount_due;
    }

    return null;
  }

  get manual() {
    const manual = this.items.find((item) => item.payment_provider === 'manual' && !item.has_expired);
    if (manual === undefined || manual === 'undefined') {
      return null;
    }
    return manual;
  }

  get hasSubscriptionThroughOtherProvider() {
    const sub = this.items.find((item) => item.payment_provider !== 'stripe' && item.payment_provider !== 'manual' && !item.has_expired);
    return sub !== undefined && sub !== 'undefined';
  }

  get otherProvider() {
    const sub = this.items.find((item) => item.payment_provider !== 'stripe' && item.payment_provider !== 'manual' && !item.has_expired);
    const s = sub.payment_provider;
    if (s === 'itunes') {
      return 'Apple';
    }
    return s.charAt(0).toUpperCase() + s.slice(1);
  }

  get hasChallengeSubscription() {
    const manualSubscription = this.manual;
    if (manualSubscription === null) {
      return false;
    }
    return manualSubscription.payment_provider_subscription_id.startsWith('challenge.');
  }

  get currentDiscount() {
    const { stripe } = this;
    if (stripe && stripe.upcoming_invoice && stripe.upcoming_invoice.discount) {
      return stripe.upcoming_invoice.discount.coupon;
    }
    return null;
  }

  static isDiscountActive(subscription) {
    let hasActiveDiscount = false;
    if (subscription !== null) {
      if (subscription.upcoming_invoice !== null && subscription.upcoming_invoice.discount !== null) {
        hasActiveDiscount = true;
      }
    }
    return hasActiveDiscount;
  }
}

export default UserSubscriptions;
